import __request__ from "routing/request";
export function bulkEditInvestigations(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/investigations", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listInvestigations(sort = "name", page = 1, per_page = 15, query, filters, user_timezone = "UTC", direction = "asc", archived = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/investigations", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "user_timezone": user_timezone, "sort": sort, "direction": direction, "archived": archived }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/investigations", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkArchive(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/investigations/archive", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function archive(id, archive2, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/investigations/archive/${id}/${archive2}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDeleteInvestigations(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/investigations/bulk/delete", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addEvidence(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/investigations/bulk/evidence/add", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeEvidence(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/investigations/evidence/remove/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateEvidence(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/investigations/evidence/update/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addEvidenceByidAndJSONBody(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/investigations/evidence/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function similarEventEvidence(id, eventId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/evidence/${id}/similar/event/${eventId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function similarMessageEvidence(id, index, messageId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/evidence/${id}/similar/message/${index}/${messageId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function export_(filename, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/investigations/export/${filename}`, null, {}, {
    "Accept": [
      "text/csv",
      "application/json",
      "application/yaml",
      "application/xml",
      "application/vnd.ms-excel"
    ]
  }, requestOptions);
}
export function getFilterOptions(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/investigations/filter_options", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInvestigationTeams(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/investigations/teams", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInvestigationUsers(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/investigations/users", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function editInvestigation(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/investigations/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInvestigation(id, include_logs_and_events = true, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/${id}`, null, { "include_logs_and_events": include_logs_and_events }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAgentTriage(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/${id}/ai-agent-triage`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getLogsPage(id, page = 1, per_page = 20, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/${id}/logs/paginated`, null, { "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSecurityEventsPage(id, page = 1, per_page = 20, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/investigations/${id}/security_events/paginated`, null, { "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteInvestigation(investigationId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/investigations/${investigationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addNewNote(investigationId, note, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/investigations/${investigationId}/notes`, note, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function editNote(investigationId, noteId, note, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/investigations/${investigationId}/notes/${noteId}`, note, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteNote(investigationId, noteId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/investigations/${investigationId}/notes/${noteId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
